const token = state => state.token
const getUser = state => state.user
const getInfo = state => state.info
const getNotifications = state => state.notifications

export {
  getNotifications,
  token,
  getUser,
  getInfo,
}
